import { tw } from './tw';

const layout = tw('m-auto w-full max-w-[var(--main-max-width)] px-5 md:px-8');

export { layout };
